import { useCurrentSurveySkip } from '@ferreri/minato-auth-react';
import {
  AngeplusLogo,
  Content,
  Section,
  SkeletonHeaderHome,
  TextHeading2,
} from '@ferreri/prever-component-lib';
import { LocationStateSelect } from '@ferreri/prever-component-lib/nextjs';
import dynamic from 'next/dynamic';
import { ReactNode, useEffect } from 'react';

import { SkeletonHome } from '../../components/skeletons/SkeletonHomePage';
import { SETTINGS } from '../../config/settings';

import { useSendAccountToWebView } from '../web-view-message/web-view-message.store';
import { CardMembershipSection } from './cardMembership/CardMembershipSection';
import { ClubeSection } from './ClubeSection';
import { useSocialLoginAlert } from './home.store';
import { MostViewedSection } from './MostViewedSection';
import { PlanSection } from './PlanSection';
import { PosthumousSection } from './PosthumousSection';
import { TelevetSection } from './TelevetSection';
import { NewestProductSection } from './NewestProductSection';
import { MedicalProductSection } from 'medical/components/sections';

const HeaderHomeNotification = dynamic<{ image: ReactNode }>(
  () => import('notification/HeaderHomeNotification'),
  { loading: () => <SkeletonHeaderHome />, ssr: false },
);

const PrivacyAndTermsCheck = dynamic(
  () => import('term/PrivacyAndTermsCheck'),
  {
    loading: () => null,
    ssr: false,
  },
);

export const Home = () => {
  useSocialLoginAlert();
  useSendAccountToWebView();
  const { data: surveySkip, isLoading: isLoadingSurveySkip } =
    useCurrentSurveySkip();

  useEffect(() => {
    const MAX_SKIPPED_DAYS = 15;

    const doesReachedMaxSkippedDays =
      surveySkip?.skipped === true &&
      surveySkip?.skipped_days > MAX_SKIPPED_DAYS &&
      !isLoadingSurveySkip;

    if (doesReachedMaxSkippedDays || surveySkip?.skipped === false) {
      window.location.assign(SETTINGS.public.urlProfileWeb);
      return;
    }
  }, [surveySkip, isLoadingSurveySkip]);

  if (isLoadingSurveySkip) {
    return <SkeletonHome />;
  }

  return (
    <>
      <PrivacyAndTermsCheck />
      <LocationStateSelect />
      <Content>
        <HeaderHomeNotification image={<AngeplusLogo />} />
        <CardMembershipSection />
        <MostViewedSection />
        <Section>
          <TextHeading2>Todos os serviços</TextHeading2>
        </Section>
        <PlanSection />
        <MedicalProductSection />
        <TelevetSection />
        <PosthumousSection />
        <ClubeSection />
        <NewestProductSection />
      </Content>
    </>
  );
};
